import type { IPagination, UserRoleEnum } from '../types'

export interface PaginationQueryParams {
    page: number
    limit?: number
}
export interface DateRangeQueryParams {
    startDate: string
    endDate: string
}
export interface MapQueryParams {
    latitude: number
    longitude: number
    radius: number
}

export interface ApiError<TField extends string = string> {
    field: TField
    msg: string
}

export interface ResponseType<T> {
    success: boolean
    data: T
    message?: string
    token?: string
    errors?: Array<ApiError>
    pagination?: IPagination
}

export interface RegisterResponseType {
    success: boolean
    token?: string
    message?: string
    errors?: Array<{
        field: string
        msg: string
    }>
}

export interface LoginResponseType {
    success: boolean
    data: {
        token: string
        roles: UserRoleEnum[]
    }
    message?: string
    errors?: Array<{
        field: string
        msg: string
    }>
}

export interface LoginRequestType {
    email: string
    password: string
}

export interface ServiceFormType {
    name: string
    description: string
    price: string
    thumbail: File | string
    categoryId: string
}

export interface ServicesByIDResponeDataType {
    thumbail: string
    id: number
    name: string
    description: string
    userId: number
    categoryId: number
    price: number
    status: string
    isFeatured: boolean
    stripeProductId: string
    stripePriceId: string
    createdAt: Date
    updatedAt: Date
}

export enum ITenantUserStatus {
    ACTIVE = 'active',
    OFFLINE = 'offline',
    ONLINE = 'online',
}

export type TenantStatusType = `${ITenantUserStatus}`
export interface ITenantUser {
    id: number
    fullName: string
    email?: string
    twoFactorSecret?: string | null
    twoFactorAuthentication?: string | null
    language?: string
    phone?: string
    photo?: string
    status?: TenantStatusType
    notifications?: string[]
    roles: UserRoleEnum[]
}
export interface ITenantUsersResponse
    extends Pick<
        ITenantUser,
        'id' | 'fullName' | 'photo' | 'roles' | 'email'
    > {}
export interface IDashboardData {
    usersCount: number
    teamsCount: number
    wgCount: number
    activeOrdersCount: number
    completedOrdersCount: number
    randomUsers: ITenantUser[]
    randomTeams: any[]
}

export interface IUsersResponse {
    success: boolean
    data: ITenantUser[]
    pagination: IPagination
}
